import { render, staticRenderFns } from "./ReputationScore.vue?vue&type=template&id=0a521a48&"
import script from "./ReputationScore.vue?vue&type=script&lang=js&"
export * from "./ReputationScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports